import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { HEADER_EVENTS, HeaderActionEvent, HeaderItem } from './header-events.model';

/**
 * App Header Event Producer
 *
 * Publishes user interaction events to the event bus.
 * Feature modules subscribe via their own header action consumers.
 */
@Service()
export class HeaderEventProducerService {
	private readonly eventBus = inject(EventBusService);

	publishItemClick(item: HeaderItem): void {
		const event: HeaderActionEvent = { eventId: item.eventId };
		this.eventBus.dispatch(HEADER_EVENTS.ACTION, event);
	}
}
